(function (root, factory) {
  if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.FoxappyJourneysCore = factory();
  }
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";

  var WAIT_UNITS = {
    minuto: "minutes",
    minutos: "minutes",
    minute: "minutes",
    minutes: "minutes",
    hora: "hours",
    horas: "hours",
    hour: "hours",
    hours: "hours",
    dia: "days",
    dias: "days",
    day: "days",
    days: "days"
  };

  function trim(value) {
    return String(value == null ? "" : value).trim();
  }

  function compactList(value) {
    if (Array.isArray(value)) {
      return value.map(trim).filter(Boolean);
    }
    return trim(value).split(",").map(trim).filter(Boolean);
  }

  function stableStepId(node) {
    if (!node) return "";
    var raw = trim(node.step_id || node.stepId || node.id);
    var slug = raw.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    if (!slug) slug = "step";
    if (slug.indexOf("step_") !== 0) slug = "step_" + slug;
    return slug;
  }

  function normalizeWaitUnit(unit) {
    return WAIT_UNITS[trim(unit).toLowerCase()] || trim(unit);
  }

  function firstOutgoing(edges, nodeId) {
    return edges.find(function (edge) {
      return edge && edge.from === nodeId;
    }) || null;
  }

  function edgeTargetStepId(edge, nodeById) {
    if (!edge) return "";
    var target = nodeById[edge.to];
    if (!target || target.type === "exit") return "";
    return stableStepId(target);
  }

  function labeledOutgoing(edges, nodeId, label) {
    var normalized = trim(label).toUpperCase();
    return edges.find(function (edge) {
      return edge && edge.from === nodeId && trim(edge.label).toUpperCase() === normalized;
    }) || null;
  }

  var NUMERIC_CONDITION_OPS = { greater_than: 1, greater_or_equal: 1, less_than: 1, less_or_equal: 1 };
  var NUMERIC_CONDITION_FIELDS = {
    "purchases.count": 1, "purchases.total_spent": 1, "purchases.average_ticket": 1,
    "purchases.last_value": 1, "purchases.days_since_last": 1
  };

  function conditionFromNode(config) {
    var field = trim(config.field || config.conditionField);
    var operator = trim(config.operator || config.conditionOperator || "equals");
    var value = config.value != null ? config.value : config.conditionValue;
    if (!field) return [];
    var condition = { field: field, operator: operator };
    if (operator !== "exists" && operator !== "not_exists") {
      // value dos campos/operadores numéricos deve ir como número, nunca string.
      if ((NUMERIC_CONDITION_OPS[operator] || NUMERIC_CONDITION_FIELDS[field]) && value !== "" && value != null && isFinite(Number(value))) value = Number(value);
      condition.value = value;
    }
    return [condition];
  }

  function withNext(step, nextStepId) {
    if (nextStepId) step.next_step_id = nextStepId;
    return step;
  }

  function stepFromNode(node, nextStepId, branchTargets) {
    var config = node.config || {};
    if (node.type === "push") {
      return withNext({
        type: "push_notification",
        title: trim(config.title),
        body: trim(config.body || config.message),
        image_url: trim(config.image_url) || undefined,
        click_url: trim(config.click_url) || undefined,
        button_text: trim(config.button_text) || undefined,
        icon_color: trim(config.icon_color) || undefined
      }, nextStepId);
    }
    if (node.type === "inapp") {
      // Schema flat nativo do app: title/content no topo (content = corpo, string).
      // oneTime é SEMPRE true (regra de produto: in-app é mostrada uma única vez —
      // nunca enviar false/omitir). Campos camelCase passam direto pro app; ttl_minutes/
      // expires_at são do contrato do step. cleanUndefined remove os vazios.
      var inApp = {
        type: "in_app_message",
        title: trim(config.title || config.contentTitle) || undefined,
        content: trim(config.body || config.content || config.message || config.contentBody) || undefined,
        image: trim(config.image) || undefined,
        buttonText: trim(config.button_text || config.buttonText) || undefined,
        buttonUrl: trim(config.button_url || config.buttonUrl) || undefined,
        background: trim(config.background) || undefined,
        oneTime: true
      };
      var ttl = Number(config.ttl_minutes || config.ttlMinutes);
      if (ttl > 0) inApp.ttl_minutes = ttl;
      else if (trim(config.expires_at || config.expiresAt)) inApp.expires_at = trim(config.expires_at || config.expiresAt);
      else inApp.ttl_minutes = 1440;
      return withNext(inApp, nextStepId);
    }
    if (node.type === "toast") {
      // Toast: banner efêmero que dispara ao navegar numa URL que CONTÉM `url` (substring).
      // oneTime SEMPRE true (regra de produto: mostra uma vez — nunca false/omitir).
      // background/color passam direto pro schema do toast; vazios usam o default do app.
      var toastStep = {
        type: "toast_message",
        message: trim(config.message) || undefined,
        url: trim(config.url) || undefined,
        background: trim(config.background) || undefined,
        color: trim(config.color) || undefined,
        oneTime: true
      };
      var ttlT = Number(config.ttl_minutes || config.ttlMinutes);
      if (ttlT > 0) toastStep.ttl_minutes = ttlT;
      else if (trim(config.expires_at || config.expiresAt)) toastStep.expires_at = trim(config.expires_at || config.expiresAt);
      else toastStep.ttl_minutes = 1440;
      return withNext(toastStep, nextStepId);
    }
    if (node.type === "webhook") {
      return withNext({
        type: "external_webhook",
        url: trim(config.url),
        method: trim(config.method || "POST").toUpperCase(),
        timeout_ms: Number(config.timeout_ms || config.timeoutMs || 5000)
      }, nextStepId);
    }
    if (node.type === "wait") {
      return withNext({
        type: "wait",
        duration: {
          amount: Number(config.amount || config.value),
          unit: normalizeWaitUnit(config.unit)
        }
      }, nextStepId);
    }
    if (node.type === "decision") {
      return {
        type: "branch",
        conditions: conditionFromNode(config),
        yes_step_id: branchTargets.yes || "",
        no_step_id: branchTargets.no || ""
      };
    }
    if (node.type === "tag") {
      return withNext({
        type: "update_customer_tag",
        tag: trim(config.tag)
      }, nextStepId);
    }
    if (node.type === "visual") {
      // change_app_visual: troca app-wide de imagens/cores. Envia só o que o lojista
      // mexeu — seção/campo vazio é omitido (o app mantém o atual no próximo boot).
      var visual = { type: "change_app_visual" };
      var splash = {};
      if (trim(config.splash_image)) splash.image = trim(config.splash_image);
      if (config.splash_full_screen === true || config.splash_full_screen === false) splash.full_screen = config.splash_full_screen;
      if (trim(config.splash_bg_color)) splash.bg_color = trim(config.splash_bg_color);
      if (trim(config.splash_text_color)) splash.text_color = trim(config.splash_text_color);
      if (Object.keys(splash).length) visual.splash = splash;
      var appbar = {};
      if (trim(config.appbar_logo)) appbar.logo = trim(config.appbar_logo);
      // Zoom do logo (opcional, independente da imagem). Envia o que o lojista pôs; a
      // validação local pega valor inválido (espelha o backend → configs/appBar.imgSize).
      if (config.appbar_img_size !== "" && config.appbar_img_size != null && isFinite(Number(config.appbar_img_size))) appbar.img_size = Number(config.appbar_img_size);
      if (trim(config.appbar_bg_color)) appbar.bg_color = trim(config.appbar_bg_color);
      if (trim(config.appbar_icons_color)) appbar.icons_color = trim(config.appbar_icons_color);
      if (Object.keys(appbar).length) visual.appbar = appbar;
      var app = {};
      if (trim(config.app_primary_color)) app.primary_color = trim(config.app_primary_color);
      if (Object.keys(app).length) visual.app = app;
      return withNext(visual, nextStepId);
    }
    return { type: node.type };
  }

  function cleanUndefined(value) {
    if (Array.isArray(value)) {
      return value.map(cleanUndefined);
    }
    if (value && typeof value === "object") {
      Object.keys(value).forEach(function (key) {
        if (value[key] === undefined || value[key] === "") {
          delete value[key];
        } else {
          value[key] = cleanUndefined(value[key]);
        }
      });
    }
    return value;
  }

  function buildJourneyPayload(input) {
    var nodes = Array.isArray(input.nodes) ? input.nodes : [];
    var edges = Array.isArray(input.edges) ? input.edges : [];
    var appId = trim(input.appId);
    var triggerType = trim(input.triggerType || "event");
    var nodeById = {};
    nodes.forEach(function (node) {
      nodeById[node.id] = node;
    });

    var entrance = nodes.find(function (node) { return node.type === "entrance"; }) || null;
    var startEdge = entrance ? firstOutgoing(edges, entrance.id) : null;
    var startNode = startEdge ? nodeById[startEdge.to] : null;
    var steps = {};

    nodes.forEach(function (node) {
      if (!node || node.type === "entrance" || node.type === "exit") return;
      var nextStepId = edgeTargetStepId(firstOutgoing(edges, node.id), nodeById);
      var branchTargets = {
        yes: edgeTargetStepId(labeledOutgoing(edges, node.id, "SIM") || labeledOutgoing(edges, node.id, "YES"), nodeById),
        no: edgeTargetStepId(labeledOutgoing(edges, node.id, "NAO") || labeledOutgoing(edges, node.id, "NÃO") || labeledOutgoing(edges, node.id, "NO"), nodeById)
      };
      steps[stableStepId(node)] = cleanUndefined(stepFromNode(node, nextStepId, branchTargets));
    });

    var entryTrigger = { type: triggerType };
    if (triggerType === "event") entryTrigger.event_type = trim(input.eventType);
    if (triggerType === "purchase_count") entryTrigger.threshold = Math.trunc(Number(input.threshold));

    var journeyId = trim(input.journeyId);
    var versionNumber = Number(input.version) > 0 ? Number(input.version) : 1;

    var journey = { name: trim(input.name) };
    if (journeyId) journey.journey_id = journeyId;

    var version = {
      journey_id: journeyId || undefined,
      version: versionNumber,
      app_id: appId,
      entry_trigger: entryTrigger,
      entry_conditions: Array.isArray(input.entryConditions) ? input.entryConditions : [],
      exit_events: compactList(input.exitEvents),
      goal_events: compactList(input.goalEvents),
      start_step_id: startNode && startNode.type !== "exit" ? stableStepId(startNode) : "",
      steps: steps
    };
    if (!journeyId) delete version.journey_id;

    return { journey: journey, version: version };
  }

  function validateUrl(value) {
    try {
      var url = new URL(value);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch (err) {
      return false;
    }
  }

  function isHexColor(value) {
    return /^#[0-9a-fA-F]{6}$/.test(String(value == null ? "" : value).trim());
  }

  // change_app_visual: mesma validação do backend. Campo no código (invalid_color/
  // invalid_image_url) usa o caminho pontilhado do contrato (ex.: splash.bg_color);
  // o stepId vai no fim para o front mapear o erro ao bloco.
  function validateVisualStep(stepId, step, errors) {
    var splash = step.splash && typeof step.splash === "object" ? step.splash : null;
    var appbar = step.appbar && typeof step.appbar === "object" ? step.appbar : null;
    var app = step.app && typeof step.app === "object" ? step.app : null;
    var hasAny = (splash && Object.keys(splash).length) || (appbar && Object.keys(appbar).length) || (app && Object.keys(app).length);
    if (!hasAny) { errors.push("change_app_visual_requires_at_least_one_change:" + stepId); return; }
    if (splash && trim(splash.image) && !validateUrl(splash.image)) errors.push("change_app_visual_invalid_image_url:splash.image:" + stepId);
    if (appbar && trim(appbar.logo) && !validateUrl(appbar.logo)) errors.push("change_app_visual_invalid_image_url:appbar.logo:" + stepId);
    [
      ["splash.bg_color", splash && splash.bg_color],
      ["splash.text_color", splash && splash.text_color],
      ["appbar.bg_color", appbar && appbar.bg_color],
      ["appbar.icons_color", appbar && appbar.icons_color],
      ["app.primary_color", app && app.primary_color]
    ].forEach(function (pair) {
      if (trim(pair[1]) && !isHexColor(pair[1])) errors.push("change_app_visual_invalid_color:" + pair[0] + ":" + stepId);
    });
    if (splash && trim(splash.bg_color) && !trim(splash.text_color)) errors.push("change_app_visual_splash_bg_requires_text_color:" + stepId);
    if (appbar && trim(appbar.bg_color) && !trim(appbar.icons_color)) errors.push("change_app_visual_appbar_bg_requires_icons_color:" + stepId);
    if (appbar && appbar.img_size !== undefined && appbar.img_size !== null && appbar.img_size !== "") {
      var size = Number(appbar.img_size);
      if (!isFinite(size) || Math.floor(size) !== size || size <= 0) errors.push("change_app_visual_invalid_img_size:" + stepId);
    }
  }

  function validateRequiredStepFields(stepId, step, errors) {
    if (step.type === "push_notification") {
      if (!trim(step.title)) errors.push("push_notification_requires_title:" + stepId);
      if (!trim(step.body)) errors.push("push_notification_requires_body:" + stepId);
      if (trim(step.image_url) && !validateUrl(step.image_url)) errors.push("push_notification_invalid_image_url:" + stepId);
      if (trim(step.click_url) && !validateUrl(step.click_url)) errors.push("push_notification_invalid_click_url:" + stepId);
    } else if (step.type === "in_app_message") {
      if (!trim(step.content) && !trim(step.image)) errors.push("in_app_message_requires_content_or_image:" + stepId);
      if (!step.ttl_minutes && !step.end_time && !step.expires_at) errors.push("in_app_message_requires_expiration:" + stepId);
    } else if (step.type === "toast_message") {
      if (!trim(step.message)) errors.push("toast_message_requires_message:" + stepId);
      if (!trim(step.url)) errors.push("toast_message_requires_url:" + stepId);
      if (!step.ttl_minutes && !step.end_time && !step.expires_at) errors.push("toast_message_requires_expiration:" + stepId);
    } else if (step.type === "external_webhook") {
      if (!validateUrl(step.url)) errors.push("external_webhook_requires_http_url:" + stepId);
    } else if (step.type === "wait") {
      if (!step.duration || !(Number(step.duration.amount) > 0)) errors.push("wait_requires_positive_duration:" + stepId);
      if (!step.duration || ["minutes", "hours", "days"].indexOf(step.duration.unit) === -1) errors.push("wait_requires_valid_unit:" + stepId);
    } else if (step.type === "branch") {
      if (!trim(step.yes_step_id)) errors.push("branch_requires_yes_step_id:" + stepId);
      if (!trim(step.no_step_id)) errors.push("branch_requires_no_step_id:" + stepId);
    } else if (step.type === "update_customer_tag") {
      if (!trim(step.tag)) errors.push("update_customer_tag_requires_tag:" + stepId);
    } else if (step.type === "change_app_visual") {
      validateVisualStep(stepId, step, errors);
    }
  }

  function referencedStepIds(step) {
    var ids = [];
    ["next_step_id", "yes_step_id", "no_step_id"].forEach(function (key) {
      if (trim(step[key])) ids.push(trim(step[key]));
    });
    return ids;
  }

  function detectLoops(steps) {
    var errors = [];
    var visiting = {};
    var visited = {};

    function walk(stepId, trail) {
      if (visiting[stepId]) {
        errors.push("journey_loop_not_supported:" + stepId);
        return;
      }
      if (visited[stepId]) return;
      visiting[stepId] = true;
      var step = steps[stepId];
      if (step) {
        referencedStepIds(step).forEach(function (nextId) {
          if (steps[nextId]) walk(nextId, trail.concat(stepId));
        });
      }
      visiting[stepId] = false;
      visited[stepId] = true;
    }

    Object.keys(steps).forEach(function (stepId) {
      walk(stepId, []);
    });
    return errors.filter(function (item, index) {
      return errors.indexOf(item) === index;
    });
  }

  function validateJourneyPayload(payload) {
    var errors = [];
    var journey = payload && payload.journey ? payload.journey : {};
    var version = payload && payload.version ? payload.version : {};
    var steps = version.steps && typeof version.steps === "object" ? version.steps : {};

    if (!trim(version.app_id)) errors.push("journey_version_requires_app_id");
    if (!version.entry_trigger || !trim(version.entry_trigger.type)) errors.push("journey_requires_entry_trigger");
    if (version.entry_trigger && version.entry_trigger.type === "event" && !trim(version.entry_trigger.event_type)) errors.push("journey_entry_trigger_requires_event_type");
    if (version.entry_trigger && version.entry_trigger.type === "purchase_count") {
      var threshold = version.entry_trigger.threshold;
      if (typeof threshold !== "number" || !isFinite(threshold) || Math.floor(threshold) !== threshold || threshold < 1) errors.push("journey_purchase_count_requires_threshold");
    }
    if (!Object.keys(steps).length) errors.push("journey_requires_steps");
    if (!trim(version.start_step_id) || !steps[version.start_step_id]) errors.push("journey_requires_valid_start_step");

    Object.keys(steps).forEach(function (stepId) {
      var step = steps[stepId];
      validateRequiredStepFields(stepId, step, errors);
      referencedStepIds(step).forEach(function (ref) {
        if (!steps[ref]) errors.push("step_reference_not_found:" + stepId + ":" + ref);
      });
    });
    errors = errors.concat(detectLoops(steps));

    return { ok: errors.length === 0, errors: errors };
  }

  function createJourneyRequest(input) {
    var endpoint = trim(input.endpoint).replace(/\/+$/, "");
    var method = trim(input.method || "GET").toUpperCase();
    var query = input.query || {};
    var url = new URL(endpoint);
    Object.keys(query).forEach(function (key) {
      if (query[key] != null && query[key] !== "") url.searchParams.set(key, query[key]);
    });
    var headers = {
      "Content-Type": "application/json",
      "x-api-key": trim(input.apiKey),
      "x-app-id": trim(input.appId)
    };
    var options = { method: method, headers: headers };
    if (input.body != null && method !== "GET") options.body = JSON.stringify(input.body);
    return { url: url.toString(), options: options };
  }

  // ---------------------------------------------------------------------------
  // Layout: deriva uma sequência linear com ramos (colunas) a partir do grafo
  // nós/arestas. Decisões viram { branches:[{label,tone,items},...] }; os ramos
  // reconvergem no "merge" (primeiro nó alcançável por ambos, normalmente a saída).
  // Retorna uma árvore de itens { id, type, branches? } para a camada de render.
  // ---------------------------------------------------------------------------
  function layoutGraph(nodes, edges) {
    nodes = Array.isArray(nodes) ? nodes : [];
    edges = Array.isArray(edges) ? edges : [];
    var byId = {};
    nodes.forEach(function (n) { if (n && n.id != null) byId[n.id] = n; });

    function outgoing(id) { return edges.filter(function (e) { return e && e.from === id; }); }
    function firstNext(id) {
      var list = outgoing(id);
      return list.length ? list[0].to : null;
    }
    function labeledTarget(id, names) {
      var wanted = names.map(function (s) { return s.toUpperCase(); });
      var match = edges.find(function (e) {
        return e && e.from === id && wanted.indexOf(trim(e.label).toUpperCase()) !== -1;
      });
      return match ? match.to : null;
    }
    function reachable(startId) {
      var seen = {};
      var stack = startId ? [startId] : [];
      while (stack.length) {
        var cur = stack.pop();
        if (cur == null || seen[cur]) continue;
        seen[cur] = true;
        outgoing(cur).forEach(function (e) { if (!seen[e.to]) stack.push(e.to); });
      }
      return seen;
    }
    function findMerge(aStart, bStart) {
      if (!aStart) return bStart || null;
      if (!bStart) return aStart || null;
      var fromB = reachable(bStart);
      // BFS a partir de aStart; primeiro nó também alcançável a partir de bStart é o merge
      var queue = [aStart], seen = {};
      while (queue.length) {
        var cur = queue.shift();
        if (cur == null || seen[cur]) continue;
        seen[cur] = true;
        if (fromB[cur]) return cur;
        outgoing(cur).forEach(function (e) { queue.push(e.to); });
      }
      return null;
    }

    var entrance = nodes.find(function (n) { return n && n.type === "entrance"; });
    var exit = nodes.find(function (n) { return n && n.type === "exit"; });
    var exitId = exit ? exit.id : null;

    function walk(startId, stopId, guard) {
      var list = [];
      var cur = startId;
      while (cur != null && cur !== stopId && !guard[cur]) {
        var node = byId[cur];
        if (!node) break;
        guard[cur] = true;
        if (node.type === "decision") {
          var yes = labeledTarget(cur, ["SIM", "YES"]);
          var no = labeledTarget(cur, ["NAO", "NÃO", "NO"]);
          var merge = findMerge(yes || stopId || exitId, no || stopId || exitId) || stopId || exitId;
          list.push({
            id: node.id,
            type: node.type,
            branches: [
              { label: "Sim", tone: "teal", items: yes && yes !== merge ? walk(yes, merge, guard) : [] },
              { label: "Não", tone: "amber", items: no && no !== merge ? walk(no, merge, guard) : [] }
            ]
          });
          cur = merge;
        } else {
          list.push({ id: node.id, type: node.type });
          cur = firstNext(cur);
        }
      }
      return list;
    }

    var startId = entrance ? entrance.id : (nodes[0] ? nodes[0].id : null);
    return walk(startId, null, {});
  }

  return {
    buildJourneyPayload: buildJourneyPayload,
    compactList: compactList,
    createJourneyRequest: createJourneyRequest,
    layoutGraph: layoutGraph,
    stableStepId: stableStepId,
    validateJourneyPayload: validateJourneyPayload
  };
});